const profile_photo = require("../assets/images/dummy_profile/profile_photo.png");

export default {
    profile_photo,
}